<template>
  <li class="list-item" :item="item">
    <slot />
    <span class="list-item-actions">
      <router-link :to="`/${model}/${item.slug}`">View</router-link>
      <router-link
        v-if="isAuthenticated && canUpdate(user)"
        :to="`/${model}/${item.slug}/edit`"
      >Edit</router-link>
      <button v-if="isAuthenticated && canRemove(user)" @click="handleRemove">Remove</button>
    </span>
  </li>
</template>

<script>
import { canUpdate, canRemove, showPrompt } from '../../utils/helpers';

export default {
  name: 'ListItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    model: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    isAuthenticated() {
      return this.user && Object.keys(this.user).length;
    }
  },
  methods: {
    canUpdate,
    canRemove,
    handleRemove() {
      showPrompt();

      this.$emit('onRemove', {
        slug: this.item.slug
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.list-item {
  list-style: none;
  border: 1px solid $accent-color;
  background-color: #fff;
  padding: 10px 15px;
  margin: 5px 0;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  span {
    flex: 1;
    font-size: 14px;
    min-width: 120px;
    display: block;
    padding: 0 5px;
  }

  .list-item-actions {
    min-width: 200px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    a,
    button {
      padding: 0 10px;
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
      color: $accent-color;
      transition: color .3s;

      &:hover {
        text-decoration: none;
        color: lighten($accent-color, 10%);
      }
    }
  }
}
</style>


